import React from 'react'

import SinglePageNavbar from '../components/single-page-navbar'
import Feature from '../components/feature'
import AboutOne from '../components/about-one'
import Price from '../components/price'
import Blog from '../components/blog'
import Contact from '../components/contact'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import HomeBanner from '../components/home-banner'
import Cta from '../components/cta'
import Team from '../components/team'
import Faq from '../components/faq'

import faqImg from '../assets/images/faqs.svg'

export default function Onepage() {
  return (
    <>
    <SinglePageNavbar/>

    <HomeBanner/>

    <section className="section overflow-hidden" id="services">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Our Features</h4>
                        <p className="text-muted para-desc mb-0 mx-auto">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
                    </div>
                </div>
            </div>
            <Feature/>
        </div>

        <div className="container mt-100 mt-60">
            <AboutOne/>
        </div>
    </section>

    <Cta/>

    <section className="section" id="pricing">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Pricing Plans</h4>
                        <p className="text-muted para-desc mx-auto mb-0">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
                    </div>
                </div>
            </div>
            <Price/>
        </div>
    </section>

    <section className="section bg-light" id="team">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Our Minds</h4>
                        <p className="text-muted para-desc mx-auto mb-0">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
                    </div>
                </div>
            </div>
            <Team/>
        </div>

        <div className="container mt-100 mt-60">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                    <div className="position-relative">
                        <img src={faqImg} className="img-fluid" alt=""/>
                        <div className="modern-app-round round-small"></div>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6 mt-4 mt-md-0 pt-2 pt-md-0">
                    <div className="section-title mb-4 ms-lg-3">
                        <h4 className="title mb-3">Frequently Asked Questions</h4>
                        <p className="text-muted para-desc mb-4">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
                    
                        <Faq/>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="section" id="blogs">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Blog Or News</h4>
                        <p className="text-muted para-desc mx-auto mb-0">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
                    </div>
                </div>
            </div>
            <Blog/>
        </div>
    </section>

    <section className="section bg-light" id="contactus">
        <Contact/>
    </section>

    <Footer/>

    <ScrollToTop/>
    </>
  )
}
